package flagpack.icons.small

import androidx.compose.foundation.Image
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.padding
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.PathData
import androidx.compose.ui.graphics.vector.group
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import flagpack.icons.FlagIcons
import org.jetbrains.compose.ui.tooling.preview.Preview

/**
 * Tajikistan Flag (16x12dp)
 *
 * - ISO Alpha-2: TJ
 * - ISO Alpha-3: TJK
 * - ISO Numeric: 762
 *
 * @see [Flagpack](https://flagpack.xyz)
 */
public val FlagIcons.Small.Tajikistan: ImageVector by lazy {
    ImageVector.Builder(
        name = "Tajikistan:TJ:TJK:762:Small",
        defaultWidth = 16.dp,
        defaultHeight = 12.dp,
        viewportWidth = 16f,
        viewportHeight = 12f
    ).apply {
        group(
            clipPathData = PathData {
                moveTo(0f, 0f)
                horizontalLineToRelative(16f)
                verticalLineToRelative(12f)
                horizontalLineToRelative(-16f)
                close()
            }
        ) {
            path(fill = SolidColor(Color.White)) {
                moveTo(0f, 0f)
                horizontalLineToRelative(16f)
                verticalLineToRelative(12f)
                horizontalLineToRelative(-16f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFF7FCFF)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(0f, 0f)
                horizontalLineTo(16f)
                verticalLineTo(12f)
                horizontalLineTo(0f)
                verticalLineTo(0f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFC51918)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(0f, 0f)
                verticalLineTo(4f)
                horizontalLineTo(16f)
                verticalLineTo(0f)
                horizontalLineTo(0f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFF409100)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(0f, 8f)
                verticalLineTo(12f)
                horizontalLineTo(16f)
                verticalLineTo(8f)
                horizontalLineTo(0f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFFFBB00)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(7.973f, 7.789f)
                curveTo(7.766f, 7.795f, 7.629f, 7.577f, 7.629f, 7.577f)
                lineTo(7.84f, 7.522f)
                curveTo(7.854f, 7.383f, 7.949f, 7.308f, 7.949f, 7.308f)
                curveTo(8.012f, 7.349f, 8.081f, 7.532f, 8.081f, 7.532f)
                lineTo(8.262f, 7.558f)
                curveTo(8.262f, 7.558f, 8.179f, 7.783f, 7.973f, 7.789f)
                close()
                moveTo(6.965f, 7.851f)
                curveTo(6.762f, 7.886f, 6.595f, 7.689f, 6.595f, 7.689f)
                lineTo(6.797f, 7.605f)
                curveTo(6.791f, 7.465f, 6.875f, 7.379f, 6.875f, 7.379f)
                curveTo(6.944f, 7.41f, 7.037f, 7.582f, 7.037f, 7.582f)
                horizontalLineTo(7.22f)
                curveTo(7.22f, 7.582f, 7.169f, 7.816f, 6.965f, 7.851f)
                close()
                moveTo(6.241f, 8.049f)
                lineTo(6.334f, 8.377f)
                curveTo(6.812f, 8.248f, 7.367f, 8.183f, 7.998f, 8.183f)
                curveTo(8.63f, 8.183f, 9.185f, 8.248f, 9.663f, 8.377f)
                lineTo(9.755f, 8.049f)
                curveTo(9.245f, 7.911f, 8.659f, 7.842f, 7.998f, 7.842f)
                curveTo(7.337f, 7.842f, 6.751f, 7.911f, 6.241f, 8.049f)
                close()
                moveTo(9.37f, 7.723f)
                curveTo(9.37f, 7.723f, 9.204f, 7.92f, 9f, 7.885f)
                curveTo(8.797f, 7.85f, 8.746f, 7.616f, 8.746f, 7.616f)
                horizontalLineTo(8.929f)
                curveTo(8.929f, 7.616f, 9.022f, 7.444f, 9.09f, 7.413f)
                curveTo(9.09f, 7.413f, 9.175f, 7.5f, 9.168f, 7.639f)
                lineTo(9.37f, 7.723f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFFFBB00)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(7.979f, 6.849f)
                curveTo(7.979f, 6.849f, 7.745f, 7.386f, 7.375f, 7.427f)
                curveTo(7.006f, 7.469f, 6.819f, 7.122f, 6.819f, 7.122f)
                curveTo(6.819f, 7.122f, 6.794f, 7.483f, 6.356f, 7.622f)
                curveTo(5.917f, 7.761f, 5.686f, 7.205f, 5.686f, 7.205f)
                curveTo(5.686f, 7.205f, 5.915f, 7.41f, 6.269f, 7.321f)
                curveTo(6.623f, 7.232f, 6.763f, 6.903f, 6.763f, 6.903f)
                curveTo(6.763f, 6.903f, 7.025f, 7.246f, 7.375f, 7.074f)
                curveTo(7.726f, 6.903f, 7.92f, 6.694f, 7.92f, 6.493f)
                verticalLineTo(5.892f)
                curveTo(7.92f, 5.892f, 7.83f, 5.736f, 7.673f, 5.736f)
                curveTo(7.516f, 5.736f, 7.472f, 5.846f, 7.472f, 5.846f)
                curveTo(7.472f, 5.846f, 7.411f, 5.221f, 7.975f, 5.183f)
                lineTo(7.975f, 5.181f)
                lineTo(7.991f, 5.182f)
                lineTo(8.006f, 5.181f)
                lineTo(8.006f, 5.183f)
                curveTo(8.571f, 5.221f, 8.51f, 5.846f, 8.51f, 5.846f)
                curveTo(8.51f, 5.846f, 8.466f, 5.736f, 8.309f, 5.736f)
                curveTo(8.152f, 5.736f, 8.061f, 5.892f, 8.061f, 5.892f)
                verticalLineTo(6.493f)
                curveTo(8.061f, 6.694f, 8.255f, 6.903f, 8.606f, 7.074f)
                curveTo(8.957f, 7.246f, 9.219f, 6.903f, 9.219f, 6.903f)
                curveTo(9.219f, 6.903f, 9.359f, 7.232f, 9.713f, 7.321f)
                curveTo(10.067f, 7.41f, 10.295f, 7.205f, 10.295f, 7.205f)
                curveTo(10.295f, 7.205f, 10.064f, 7.761f, 9.626f, 7.622f)
                curveTo(9.187f, 7.483f, 9.163f, 7.122f, 9.163f, 7.122f)
                curveTo(9.163f, 7.122f, 8.975f, 7.469f, 8.606f, 7.427f)
                curveTo(8.237f, 7.386f, 8.002f, 6.849f, 8.002f, 6.849f)
                lineTo(7.991f, 6.141f)
                lineTo(7.979f, 6.849f)
                close()
                moveTo(7.974f, 5.351f)
                curveTo(7.714f, 5.351f, 7.661f, 5.571f, 7.661f, 5.571f)
                curveTo(7.89f, 5.571f, 7.974f, 5.671f, 7.974f, 5.671f)
                curveTo(7.974f, 5.671f, 8.144f, 5.571f, 8.315f, 5.571f)
                curveTo(8.315f, 5.571f, 8.234f, 5.351f, 7.974f, 5.351f)
                close()
            }
            path(fill = SolidColor(Color(0xFFFFBB00))) {
                moveTo(5.95f, 6.499f)
                lineTo(4.954f, 6.585f)
                curveTo(4.881f, 5.733f, 5.232f, 4.927f, 5.968f, 4.189f)
                curveTo(7.052f, 3.102f, 9.247f, 3.208f, 10.181f, 4.199f)
                curveTo(10.715f, 4.765f, 10.988f, 5.549f, 11.014f, 6.528f)
                lineTo(10.015f, 6.555f)
                curveTo(9.995f, 5.805f, 9.803f, 5.256f, 9.453f, 4.885f)
                curveTo(8.896f, 4.294f, 7.35f, 4.22f, 6.676f, 4.895f)
                curveTo(6.134f, 5.438f, 5.905f, 5.966f, 5.95f, 6.499f)
                close()
            }
        }
    }.build()
}

@Preview
@Composable
private fun TajikistanPreview() {
    Box(modifier = Modifier.padding(12.dp)) {
        Image(
            imageVector = FlagIcons.Small.Tajikistan,
            contentDescription = "Tajikistan Flag"
        )
    }
}
